import React from "react";

const websocket = {
  id: "websocket-group",
  type: "group",
  children: [
    {
      id: "websocket",
      title: "WebSocket",
      type: "item",
      url: "/websocket",
      icon: React.createElement(
        "svg",
        {
          width: 20,
          height: 20,
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: 2,
          strokeLinecap: "round",
          strokeLinejoin: "round",
        },
        React.createElement("path", {
          d: "M13 2L3 14h9l-1 8 10-12h-9l1-8z",
        }),
      ),
    },
  ],
};

export default websocket;
